import { render, staticRenderFns } from "./qualityReport.vue?vue&type=template&id=a4be8714&scoped=true"
import script from "./qualityReport.vue?vue&type=script&lang=js"
export * from "./qualityReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4be8714",
  null
  
)

export default component.exports